var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('Title',[_vm._v("Services")]),_c('ServiceList',{attrs:{"services":_vm.servicesColumn1}}),_c('ServiceList',{attrs:{"services":_vm.servicesColumn2}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }